import React from 'react';
import { Trophy, Users, Target, Clock } from 'lucide-react';
import useHomePageContent from '../../hooks/useHomePageContent';

const AboutTeam = () => {
  const { content } = useHomePageContent();

  const features = [
    {
      icon: Trophy,
      title: content.feature_1_title,
      description: content.feature_1_desc,
    },
    {
      icon: Users,
      title: content.feature_2_title,
      description: content.feature_2_desc,
    },
    {
      icon: Target,
      title: content.feature_3_title,
      description: content.feature_3_desc,
    },
    {
      icon: Clock,
      title: content.feature_4_title,
      description: content.feature_4_desc,
    },
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-gray-900 to-gray-800 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#662d91] rounded-full filter blur-3xl transform -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#28c4f4] rounded-full filter blur-3xl transform translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 text-white">{content.about_title}</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#662d91] via-[#4897d2] to-[#28c4f4] mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-[#662d91] via-[#4897d2] to-[#28c4f4] transform rotate-3 rounded-2xl"></div>
            <img
              src="/images/Leikin_team_eilat.jpg"
              alt="Тренировка"
              className="relative rounded-2xl shadow-2xl transform -rotate-3 hover:rotate-0 transition-transform duration-500"
            />
          </div>

          <div className="space-y-6">
            <h3 className="text-3xl font-bold mb-6 text-white">{content.about_subtitle}</h3>
            <p className="text-lg text-gray-300">{content.about_description_1}</p>
            <p className="text-lg text-gray-300">{content.about_description_2}</p>

            <div className="grid grid-cols-2 gap-6 mt-8">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="p-6 rounded-xl bg-white/5 backdrop-blur-md hover:bg-white/10 transition-all duration-300 group"
                >
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-r from-[#662d91] via-[#4897d2] to-[#28c4f4] p-0.5 mb-4">
                    <div className="w-full h-full bg-gray-900 rounded-lg flex items-center justify-center">
                      <feature.icon className="w-6 h-6 text-[#28c4f4] group-hover:text-white transition-colors" />
                    </div>
                  </div>
                  <h4 className="font-semibold mb-1 text-white">{feature.title}</h4>
                  <p className="text-sm text-gray-400">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-20">
          {[
            { number: content.about_stat_1_number, label: content.about_stat_1_label },
            { number: content.about_stat_2_number, label: content.about_stat_2_label },
            { number: content.about_stat_3_number, label: content.about_stat_3_label },
            { number: content.about_stat_4_number, label: content.about_stat_4_label },
          ].map((stat, index) => (
            <div key={index} className="text-center transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl font-bold bg-gradient-to-r from-[#662d91] via-[#4897d2] to-[#28c4f4] text-transparent bg-clip-text">
                {stat.number}
              </div>
              <div className="text-gray-400 mt-2">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutTeam;
